function throttle(fn, wait = 300) {
  let throttleTimeoutId = -1;
  let tick = false;

  return () => {
    clearTimeout(throttleTimeoutId);
    throttleTimeoutId = setTimeout(fn, wait);

    if (!tick) {
      fn.call();
      tick = true;
      setTimeout(() => {
        tick = false;
      }, wait);
    }
  };
}

if (!customElements.get('sticky-atc')) {
  customElements.whenDefined('product-form').then(() => {
    class StickyAtc extends customElements.get('product-form') {
      constructor() {
        super();

        this.section = this.closest('.section-main-product');
        this.buyButtons = this.section.querySelector('.quantity-submit-row');
        if (!this.buyButtons) return;

        this.imageContainer = this.querySelector('.sticky-atc__image');
        this.variantTitle = this.querySelector('.sticky-atc__details__variant__title');
        this.variantTitle?.toggleAttribute('hidden', !this.section.querySelector('variant-picker'));
        this.button = this.querySelector('.add-to-cart');

        this.throttledOnScroll = throttle(this.handleScroll.bind(this));
        window.addEventListener('scroll', this.throttledOnScroll);
        this.section.addEventListener('on:media-gallery:change', this.updateImage.bind(this));

        // Defer form resolution until product-form is fully upgraded
        this._resolveProductForm();

        this.updateImage();
        this.updateAddToCartButton();
      }

      /**
       * Resolves mainProductForm and submitForm safely.
       * Retries if product-form isn't fully initialized yet.
       */
      _resolveProductForm() {
        this.mainProductForm = this.section.querySelector('product-form');

        if (this.mainProductForm && typeof this.mainProductForm.getSubmitForm === 'function') {
          this.mainProductSubmitForm = this.mainProductForm.getSubmitForm();
        } else {
          // product-form exists in DOM but not fully upgraded yet — wait for it
          this.mainProductSubmitForm = this.section.querySelector('.js-product-form, form[action="/cart/add"]');
        }

        if (typeof this.getSubmitForm === 'function') {
          this.submitForm = this.getSubmitForm();
        } else {
          this.submitForm = this.querySelector('.js-product-form, form[action="/cart/add"]')
            || this.section.querySelector('.js-product-form, form[action="/cart/add"]');
        }
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.throttledOnScroll);
      }

      async handleSubmit(evt) {
        evt.preventDefault();

        // Re-resolve forms in case DOM was replaced by variant-picker
        this._resolveProductForm();

        const variantId = this.section.querySelector('.js-product-form input[name="id"]')?.value;
        if (!variantId) {
          const target = this.section.querySelector('#product-info');
          if (target && target.offsetParent) {
            theme.scrollToRevealElement(target);
          }
          return;
        }

        const customFormValid = this.mainProductForm?.validate?.() ?? true;
        const submitFormValid = this.mainProductSubmitForm?.reportValidity?.() ?? true;

        if (!customFormValid || !submitFormValid) {
          evt.preventDefault();
          if (!customFormValid) {
            theme.scrollToRevealElement(this.mainProductForm);
          } else {
            const input = Array.from(this.mainProductSubmitForm?.elements ?? [])
              .find((el) => !el.checkValidity());
            setTimeout(() => theme.scrollToRevealElement(input), 100);
          }
          return;
        }

        // Clear previously copied inputs
        this.submitForm?.querySelectorAll('[data-copied]').forEach((el) => el.remove());

        // Copy form data from main form into sticky form
        const formData = new FormData(this.mainProductSubmitForm);
        for (const p of formData) {
          if (!this.submitForm?.querySelector(`[name="${p[0]}"]`)) {
            const input = document.createElement('input');
            input.name = p[0];
            input.value = p[1];
            input.hidden = true;
            input.setAttribute('data-copied', '');
            this.submitForm?.append(input);
          }
        }

        super.handleSubmit(evt);
      }

      handleScroll() {
        const topOffset = document.querySelector('.pageheader--sticky')
          ? document.querySelector('.section-header').offsetHeight
          : 0;

        this.classList.toggle(
          'sticky-atc--out',
          this.buyButtons.getBoundingClientRect().bottom > topOffset
        );

        document.body.classList.toggle(
          'scrolled-to-bottom',
          window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
        );
      }

      updateImage() {
        const mainImage = this.section.querySelector(
          '.media-gallery .main-image .slider__item.is-active .product-media img'
        );
        if (mainImage) {
          this.imageContainer.innerHTML = mainImage.outerHTML;
        } else {
          this.imageContainer.textContent = '';
        }
      }

      updateAddToCartButton() {
        const variantId = this.section.querySelector('.js-product-form input[name="id"]')?.value;
        if (!variantId) {
          this.button.innerHTML = this.button.dataset.unavailableText;
        }
      }
    }

    customElements.define('sticky-atc', StickyAtc);
  });
}